<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <app-data
          titulo="Información del Indicador"
          :datos="indicadorDatos">
        </app-data>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Data from  '../shared/tableData.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'indicadorRentabilidadBruta/getField',
  mutationType: 'indicadorRentabilidadBruta/updateField',
});

export default {
  name: 'IndicadoresRentabilidadDatos',
  components: {
    appData: Data,
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal, 
  ],
  props: {
    semestral: {
      type: Boolean,
      default: true
    }
  },  
  data: () => {
    return {
      indicadorId: 0,
    }
  },
  computed: {
    ...mapFields([
      'indicadorDatos',
    ]),
  },
  created() {
    this.indicadorId = this.$route.params.id;

    let params = {
      semestral: this.semestral,
      indicadorId
    }

    this.$store.dispatch('indicadorRentabilidadBruta/getDatos', params)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    goBack() {
      if ((/true/i).test(this.semestral)) {
        this.$router.push({ name: 'IndicadoresRentabilidadSemestral' });
      } else {
        this.$router.push({ name: 'IndicadoresRentabilidadAnual' });
      }
    },
  }
}
</script>
